export default __webpack_public_path__ + "static/media/chia.3e0649e5.png";